// Thin animated signal line marking the handoff between homepage sections (desktop only).
export const SectionSeam = ({ label, dark }: { label?: string; dark?: boolean }) => (
  <div aria-hidden className="pointer-events-none absolute inset-x-0 top-0 z-10 max-md:hidden">
    <div className="section-seam h-px w-full" />
    {label && (
      <span className={`absolute left-8 top-4 font-mono text-[10px] uppercase tracking-[0.3em] ${dark ? "text-[hsl(0_0%_100%/0.4)]" : "text-[hsl(var(--hero-ink)/0.45)]"}`}>{label}</span>
    )}
  </div>
);
